module.exports = __webpack_public_path__ + "static/media/user.9373cdf0.svg";